import intl from "react-intl-universal";
import {
  TbArrowsLeftRight,
  TbCalendarStats,
  TbDownload,
  TbFileText,
  TbFilter,
} from "react-icons/tb";
import { MdOutlinePix } from "react-icons/md";
import { ShortcutCard } from "../../../Components/Atoms/ShortcutCard";
import { useAuth } from "../../../Contexts/AuthContext";
import { useIbProductFeaturesStore } from "../../../Stores/ibProductFeaturesStore";
import { isIbProductEnabled } from "../../../Utils/ibProductFeatures";

export const ExtractQuickActions = ({
  onExportClick,
  onOpenFilters,
  onConsolidadoDiario,
  onOpenTransfer,
}) => {
  const { hasPermission } = useAuth();
  const features = useIbProductFeaturesStore((state) => state.features);

  const actions = [
    {
      id: "pix",
      label: intl.get("words.pix"),
      icon: MdOutlinePix,
      to: "/pix",
      permission: "pixview",
      requiredFeature: "pix",
    },
    {
      id: "transferir",
      label: intl.get("words.transfer"),
      icon: TbArrowsLeftRight,
      onClick: onOpenTransfer,
      permission: "transp2p",
    },
    {
      id: "exportar",
      label: intl.get("extract.exportStatement"),
      icon: TbDownload,
      onClick: onExportClick,
      badge: intl.get("common.newBadge"),
    },
    {
      id: "comprovantes",
      label: intl.get("nav.receipts"),
      icon: TbFileText,
      to: "/comprovantes",
      permission: "receiptsview",
    },
    {
      id: "filtros",
      label: intl.get("extract.quickFilters"),
      icon: TbFilter,
      onClick: onOpenFilters,
    },
    {
      id: "consolidado",
      label: intl.get("extract.dailyConsolidated"),
      icon: TbCalendarStats,
      onClick: onConsolidadoDiario,
      badge: intl.get("common.newBadge"),
    },
  ];

  const visible = actions.filter((action) => {
    if (action.permission && !hasPermission(action.permission)) return false;
    if (action.requiredFeature && !isIbProductEnabled(features, action.requiredFeature)) {
      return false;
    }
    if (action.onClick) return typeof action.onClick === "function";
    return Boolean(action.to);
  });

  if (!visible.length) return null;

  return (
    <section className="extract-quick-actions mb-5 min-w-0 w-full max-w-full">
      <p className="dashboard-section-label mb-3">{intl.get("extract.quickActions")}</p>
      <div className="shortcut-scroll-row">
        {visible.map(({ id, label, icon, to, onClick, badge }) => (
          <ShortcutCard
            key={id}
            to={to}
            onClick={onClick}
            icon={icon}
            label={label}
            badge={badge}
          />
        ))}
      </div>
    </section>
  );
};
